module.exports = __webpack_public_path__ + "media/images/new-ui-images/select-arrow-3e7917bc936116edfb5e0d5caf83d12c.svg";